/* eslint-disable */

/**
 * Verifica se o entregador está online (últimas 2 horas)
 * @param {string} dataString - String de data no formato "YYYYMMDDHHmmss" (14 caracteres)
 * @returns {boolean} - true se o entregador está online, false caso contrário
 */
export function isEntregadorOnline(dataString) {
  if (!dataString || dataString.length !== 14) return false;

  const year = parseInt(dataString.substr(0, 4));
  const month = parseInt(dataString.substr(4, 2)) - 1;
  const day = parseInt(dataString.substr(6, 2));
  const hour = parseInt(dataString.substr(8, 2));
  const minute = parseInt(dataString.substr(10, 2));

  const dataGeolocalizacao = new Date(year, month, day, hour, minute);
  const agora = new Date();
  const diferencaMs = agora - dataGeolocalizacao;
  const diferencaHoras = diferencaMs / (1000 * 60 * 60);

  return diferencaHoras <= 2;
}

/**
 * Verifica se o entregador está disponível (bolinha verde)
 * Critérios:
 * - Status = 1 (disponível)
 * - Tem lat e lng
 * - Tem data de última geolocalização
 * - Está online nas últimas 2 horas
 * - Não tem pedidos pendentes ou a caminho
 *
 * @param {object} entregador - Objeto do entregador
 * @param {Array} pedidosPendentes - Lista de pedidos pendentes
 * @param {Array} pedidosACaminho - Lista de pedidos a caminho
 * @returns {boolean} - true se o entregador está disponível, false caso contrário
 */
export function isEntregadorDisponivel(entregador, pedidosPendentes, pedidosACaminho) {
  if (!entregador) return false;

  // Verifica se o entregador está com status disponível (1)
  // Tem lat e lng
  // Tem data de última geolocalização
  if (entregador.status !== 1 || !entregador.lat || !entregador.lng || !entregador.dataUltimaGeoLocalizacao) {
    return false;
  }

  // Verifica se está online nas últimas 2 horas
  if (!isEntregadorOnline(entregador.dataUltimaGeoLocalizacao)) {
    return false;
  }

  // Verifica se não tem pedidos pendentes ou a caminho (status disponível - bolinha verde)
  const pedidosPendentesCount = pedidosPendentes.filter(p =>
    p.entregador && p.entregador.EntregadorId === entregador.id
  ).length;

  const pedidosACaminhoCount = pedidosACaminho.filter(p =>
    p.entregador && p.entregador.EntregadorId === entregador.id
  ).length;

  // Se não tem pedidos (está realmente disponível)
  return pedidosPendentesCount === 0 && pedidosACaminhoCount === 0;
}
